import React, { useState } from "react";
import { rateReport } from "../../redux/reports/report.actions";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { makeStyles, Button, Typography } from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import { createStructuredSelector } from "reselect";
import {
  selectCurrentReport,
  selectCurrentUserRating,
} from "../../redux/reports/report.selector";
import { selectCurrentUser } from "../../redux/user/user.selector";
import WeizenIcon from "../form-inputs/weizen-icon";
import Moment from "react-moment";
import "moment/locale/de";
import { useEffect } from "react";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  green: {
    color: "#5fd75b",
  },
  button: { margin: "5px" },
}));

const RatingComponent = ({
  saveRating,
  currentUser,
  userRating,
  currentReport,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(3);
  useEffect(() => {
    console.log("useEffect");
    if (userRating && userRating.value) {
      console.log("setValue to " + userRating.value);
      setValue(userRating.value);
    } else {
      setValue(3);
    }
  }, [userRating]);

  const StyledRating =
    userRating && userRating.erstellt
      ? withStyles({
          iconFilled: {
            color: "#5fd75b",
          },
          iconHover: {
            color: "#35c530",
          },
        })(Rating)
      : Rating;
  return (
    <div className={classes.root}>
      <StyledRating
        name="bewertung"
        value={value}
        defaultValue={3}
        max={5}
        getLabelText={(value) => `${value} Ähre${value !== 1 ? "n" : ""}`}
        size="large"
        icon={<WeizenIcon style={{ padding: 0 }} />}
        onChange={(event, newValue) => {
          if (newValue) setValue(newValue);
        }}
      />
      {userRating && userRating.erstellt ? (
        <Typography variant="small" className={classes.green}>
          <Moment
            date={userRating.erstellt ? userRating.erstellt : null}
            fromNow
          ></Moment>
        </Typography>
      ) : (
        <Typography variant="small">Nicht bewertet</Typography>
      )}
      <Button
        className={classes.button}
        variant="outlined"
        onClick={() => {
          saveRating(currentReport, currentUser, value);
        }}
      >
        Bewertung abgeben
      </Button>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  saveRating: (report, user, rating) =>
    dispatch(rateReport(report, user, rating)),
});

const mapStateToProps = createStructuredSelector({
  currentReport: selectCurrentReport,
  currentUser: selectCurrentUser,
  userRating: selectCurrentUserRating,
});

export default connect(mapStateToProps, mapDispatchToProps)(RatingComponent);
